module.exports = "<p>\n  add-chips works!\n</p>\n"